import { useState } from 'react';

export function useSortable(items, campoInicial = '') {
  const [campo, setCampo] = useState(campoInicial);
  const [asc, setAsc] = useState(true);

  const sorted = [...items].sort((a, b) => {
    if (!campo) return 0;
    const va = a[campo] ?? '';
    const vb = b[campo] ?? '';
    const cmp = typeof va === 'number'
      ? va - vb
      : String(va).localeCompare(String(vb), 'pt-BR', { sensitivity: 'base' });
    return asc ? cmp : -cmp;
  });

  const handleClick = (c) => {
    if (c === campo) setAsc(v => !v);
    else { setCampo(c); setAsc(true); }
  };

  function Th({ campo: c, children, style }) {
    const active = c === campo;
    return (
      <th style={style} onClick={() => handleClick(c)}>
        <span className="d-flex align-items-center gap-1">
          {children}
          {active && (
            <span style={{ fontSize: 10 }}>{asc ? '▲' : '▼'}</span>
          )}
        </span>
      </th>
    );
  }

  return { sorted, Th };
}
